import React, { Component } from 'react';
import { Header as HeaderModule, Layout, Modal, Utils } from 'common';
import RateAdvisorWrapper from './rateAdvisor/RateAdvisorWrapper.component';

const { Util } = Utils;
const { ModalContainer } = Modal;
const { Analytics, Header } = HeaderModule;
const { TopPanel, CenterPanel, RegionType, Viewport } = Layout;

class MailView extends Component {
	constructor(props) {
		super(props);

		const showRateAdvisor = Util.isInRoute('rateadvisor');

		this.state = {
			// all in-route views
			showRateAdvisor,

			// `true` if any of in-route is true
			showInRouteView: showRateAdvisor,
		};
	}

	/**
	 * Show a specific in-route view when URL contains:
	 *  /rateadvisor - Rate Advisor
	 * @returns {ReactElement}
	 */
	renderInRouteView = () => {
		const { showRateAdvisor } = this.state;

		if (showRateAdvisor) {
			return <RateAdvisorWrapper />;
		}

		return null;
	};

	/**
	 * Render the core main view.
	 * @returns {ReactElement}
	 */
	renderCoreMainView = () => {
		const { signInCallback, showSignInView } = this.props;

		return (
			<>
				<TopPanel region={RegionType.North}>
					<Header signInCallback={signInCallback} showSignInView={showSignInView} />
					<Analytics />
				</TopPanel>
				<CenterPanel>{/* render the center view */}</CenterPanel>
			</>
		);
	};

	render() {
		const { showInRouteView } = this.state;

		// render any of in-route views
		if (showInRouteView) {
			return (
				<Viewport>
					<ModalContainer>{this.renderInRouteView()}</ModalContainer>
				</Viewport>
			);
		}

		// render core main view of Account
		return (
			<Viewport
				layout={{
					[RegionType.North]: {
						height: 50,
					},
				}}
			>
				<ModalContainer>{this.renderCoreMainView()}</ModalContainer>
			</Viewport>
		);
	}
}

export default MailView;
